
/**
 * @param {*} t
 * @return {*} 
 * @status no delete
 */
const ProfileValidator = (t) => {
  let regexs = {
    nameRegex: new RegExp(/^[A-Za-zñÑáéíóúáéíóúÁÉÍÓÚàèìòùÀÈÌÒÙ0 .,;:-]* ?()[A-Za-zñÑáéíóúáéíóúÁÉÍÓÚàèìòùÀÈÌÒÙ0 .,;:-]* ?()[A-Za-zñÑáéíóúáéíóúÁÉÍÓÚàèìòùÀÈÌÒÙ0 .,;:-]*$/),
    firstLastNameRegex: new RegExp(/^[A-Za-zñÑáéíóúáéíóúÁÉÍÓÚàèìòùÀÈÌÒÙ0 .,;:-]* ?()[A-Za-zñÑáéíóúáéíóúÁÉÍÓÚàèìòùÀÈÌÒÙ0 .,;:-]* ?()[A-Za-zñÑáéíóúáéíóúÁÉÍÓÚàèìòùÀÈÌÒÙ0 .,;:-]*$/),
    secondLastNameRegex: new RegExp(/^[A-Za-zñÑáéíóúáéíóúÁÉÍÓÚàèìòùÀÈÌÒÙ0 .,;:-]* ?()[A-Za-zñÑáéíóúáéíóúÁÉÍÓÚàèìòùÀÈÌÒÙ0 .,;:-]* ?()[A-Za-zñÑáéíóúáéíóúÁÉÍÓÚàèìòùÀÈÌÒÙ0 .,;:-]*$/),
    phoneNumberRegex: new RegExp(/^[-]?[0-9]+[\.]?[0-9]+$/),
    streetRegex: new RegExp(/^[A-Za-z0-9 áéíóúÁÉÍÓÚÑñ.,;:#-]+$/),
    internalNumberRegex: new RegExp(/^[A-Za-z0-9 áéíóúÁÉÍÓÚÑñ.,;:#-]+$/),
    colonyRegex: new RegExp(/^[A-Za-z0-9 áéíóúÁÉÍÓÚÑñ.,;:#-]+$/),
    townRegex: new RegExp(/^[A-Za-z0-9 áéíóúÁÉÍÓÚñÑ.,;:-]+$/),
    stateRegex: new RegExp(/^[A-Za-z0-9 áéíóúÁÉÍÓÚñÑ.,;:-]+$/),
    countryRegex: new RegExp(/^[A-Za-z0-9 áéíóúÁÉÍÓÚñÑ.,;:-]+$/),
    zipCodeRegex: new RegExp(/(^\d{5}$)|(^\d{5}-\d{4}$)/),
    rfcRegex: new RegExp(/^([A-ZÑ&]{3,4}) ?(?:- ?)?(\d{2}(?:0[1-9]|1[0-2])(?:0[1-9]|[12]\d|3[01])) ?(?:- ?)?([A-Z\d]{2})([A\d])$/),
    curpRegex: new RegExp(/^([A-Z&]|[a-z&]{1})([AEIOU]|[aeiou]{1})([A-Z&]|[a-z&]{1})([A-Z&]|[a-z&]{1})([0-9]{2})(0[1-9]|1[0-2])(0[1-9]|1[0-9]|2[0-9]|3[0-1])([HM]|[hm]{1})([AS|as|BC|bc|BS|bs|CC|cc|CS|cs|CH|ch|CL|cl|CM|cm|DF|df|DG|dg|GT|gt|GR|gr|HG|hg|JC|jc|MC|mc|MN|mn|MS|ms|NT|nt|NL|nl|OC|oc|PL|pl|QT|qt|QR|qr|SP|sp|SL|sl|SR|sr|TC|tc|TS|ts|TL|tl|VZ|vz|YN|yn|ZS|zs|NE|ne]{2})([^A|a|E|e|I|i|O|o|U|u]{1})([^A|a|E|e|I|i|O|o|U|u]{1})([^A|a|E|e|I|i|O|o|U|u]{1})([0-9]{2})$/),
  }

  let validators = {
    nameValidator: (value) => {
      return (regexs.nameRegex.test(value) ? '' : t("profile.validator.nameValidator"))
    },
    firstLastNameValidator: (value) => {
      return (regexs.firstLastNameRegex.test(value) ? '' : t("profile.validator.firstLastNameValidator"))
    },
    secondLastNameValidator: (value) => {
      return (regexs.secondLastNameRegex.test(value) ? '' : t("profile.validator.secondLastNameValidator"))
    },
    phoneNumberValidator: (value) => {
      return (regexs.phoneNumberRegex.test(value) ? '' : t("profile.validator.phoneNumberValidator"))
    },
    streetValidator: (value) => {
      if (value && value.length > 0) {
        return (regexs.streetRegex.test(value) ? '' : t("profile.validator.streetValidator"))
      } else {
        return ''
      }
    },
    internalNumberValidator: (value) => {
      if (value && value.length > 0) {
        return (regexs.internalNumberRegex.test(value) ? '' : t("profile.validator.internalNumberValidator"))
      } else {
        return ''
      }
    },
    colonyValidator: (value) => {
      return (regexs.colonyRegex.test(value) ? '' : t("profile.validator.colonyValidator"))
    },
    townValidator: (value) => {
      if (value) {
        return (regexs.townRegex.test(value) ? '' : t("profile.validator.townValidator"))
      } else {
        return ''
      }
    },
    stateValidator: (value) => {
      if (value) {
        return (regexs.stateRegex.test(value) ? '' : t("profile.validator.stateValidator"))
      } else {
        return ''
      }
    },
    countryValidator: (value) => {
      if (value && value.length > 0) {
        return (regexs.countryRegex.test(value) ? '' : t("profile.validator.countryValidator"))
      } else {
        return ''
      }
    },
    zipCodeValidator: (value) => {
      if (value && value.length > 0) {
        return (regexs.zipCodeRegex.test(value) ? '' : t("profile.validator.zipCodeValidator"))
      } else {
        return ''
      }
    },
    rfcValidator: (value) => {
      if (value && value.length > 0) {
        return (regexs.rfcRegex.test(value) ? '' : t("profile.validator.rfcValidator"))
      } else {
        return ''
      }
    },
    curpValidator: (value) => {
      return (regexs.curpRegex.test(value) ? '' : t("profile.validator.curpValidator"))
    }
  }

  return validators
}

export { ProfileValidator as default }
